var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"kind":"one_column"}},[_c('v-container',{attrs:{"fluid":"","pt-0":"","mt-0":"","pb-0":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('h1',{staticClass:"max"},[_vm._v(_vm._s(_vm.i18n('Usuários')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('Users')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0375d22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/UsersPage.vue
// module id = null
// module chunks = 